import { Injectable, Injector } from '@angular/core';
import { Document } from './document';
import { HttpDataService } from 'core/services/http-data.service';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class DocumentsService extends HttpDataService {
  public list: Document[];

  constructor(protected injector: Injector) {
    super(injector, '/customizations/resources/documents');
  }

  getDocument(id: string): Promise<any> {
    const url = `${this.baseUrl}/${id}`;
    return lastValueFrom(this.http.get<Document>(url, this.getRequestOptions())).catch(this.handleObservableError);
  }

  create(props: Object): Promise<Document> {
    props['url'] = this.formatVideoEmbedUrl(props['url']);
    return super.create(props);
  }

  update(document: Document): Promise<Document> {
    const url = `${this.baseUrl}/${document.id}`;
    const updateddocument: Document = Object.assign({}, document, {
      url: this.formatVideoEmbedUrl(document.url)
    });
    return super.update(updateddocument);
  }

  formatVideoEmbedUrl(url: String) {
    let newURL = [];
    if (
      url.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/) &&
      ((newURL = url.match(/(\?|&)v=([^&#]+)/)) ||
        (newURL = url.match(/(\.be\/)+([^\/]+)/)) ||
        (newURL = url.match(/(\embed\/)+([^\/]+)/)))
    ) {
      url = 'https://youtube.com/embed/' + newURL.pop().replace('?rel=0', '');
    } else if ((newURL = url.match(/(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/))) {
      url = 'https://player.vimeo.com/video/' + newURL.pop();
    }
    return url;
  }
}
